import forEach from 'lodash/forEach';
import merge from 'lodash/merge';

export const mapErrorsToModel = (errors) => {
  const modelErrors = {
    errors: {},
  };
  let formattedErrorObject = {};

  forEach(errors, (error, index) => {
    // laravel error structure differs from laraveljsonapi
    if (!error.source) {
      return (modelErrors.errors[index] = error.map((j) => j));
    }

    let model = null;
    model = error.source.pointer.match(/\/data\/attributes\/(\w+)/);
    model = model.length > 0 ? model[1] : null;
    if (model) {
      const nestedError = error.source.pointer.match(/\/data\/attributes\/data\/(.*)/);

      if (!modelErrors.errors[model]) {
        modelErrors.errors[model] = [];
      }
      if (nestedError) {
        const attributes = nestedError[1].split('/');
        const attributeKey = attributes[0];
        const attributeValue = attributes[1];

        merge(formattedErrorObject, {
          [attributeKey]: {
            [attributeValue]: [error.detail],
          },
        });

        modelErrors.errors[model] = formattedErrorObject;
      } else {
        modelErrors.errors[model].push(error.detail);
      }
    }
  });

  return modelErrors;
};
